import React, { useEffect, useState } from "react";
import Loader from "./components/ui/Loader";
import Routes from "./Routes";
import { validateAndRepairStorage } from "./utils/localStorageManager";

const App: React.FC = () => {
	const [isStorageValidated, setIsStorageValidated] = useState(false);

	useEffect(() => {
		// Validate and repair localStorage on app initialization
		// This detects corrupted data and cleans it up
		const wasCorrupted = validateAndRepairStorage();

		if (wasCorrupted) {
			console.warn("localStorage was corrupted and has been cleaned up. User may need to log in again.");
		}

		setIsStorageValidated(true);
	}, []);

	// Wait for storage validation before rendering the app
	// This prevents race conditions with corrupted data
	if (!isStorageValidated) {
		return <Loader fullScreen showText text="Initializing..." />;
	}

	return <Routes />;
};

export default App;
